import { InsuranceProducts } from "../../../constants";
var productLineHeaderText = new Map([
    [InsuranceProducts.Auto, "Savvy Offers"],
    [InsuranceProducts.Home, "Savvy Home Offers"],
]);
export function getOfferListHeaderText(_a) {
    var showBundles = _a.showBundles, productLine = _a.productLine;
    var v2ProductLineHeader = productLineHeaderText.get(productLine) ||
        productLineHeaderText.get(InsuranceProducts.Auto);
    return showBundles ? "Savvy Auto + Home Offers" : v2ProductLineHeader;
}
export function filterAdResultsForAnalytics(mixedResults) {
    var _a;
    return ((_a = mixedResults === null || mixedResults === void 0 ? void 0 : mixedResults.filter(function (result) {
        return result.adContent !== undefined;
    }).map(function (result) {
        var _a = result.adContent, id = _a.id, advertiserName = _a.advertiserName, issuerId = _a.issuerId, clickUrl = _a.clickUrl;
        return { id: id, advertiserName: advertiserName, issuerId: issuerId, clickUrl: clickUrl };
    })) !== null && _a !== void 0 ? _a : []);
}
